



















import { Getter, Action } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import { ElementUIUtil } from '@acgn/herm/src/util';
import ResetPwd from './reset-pwd.vue';

@Component({
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    ResetPwd
  }
})
export default class AccountButton extends Vue {

  @Action('desk/auth/logout') private logout: any; // 登出

  @Getter('desk/auth/userInfo') private userInfo: any; // 用户信息

  private pwdVisible: boolean = false; // 是否显示密码框

  private menuItems: any[] = [
    // { label: '修改密码', key: 'changePwd' },
    // { label: '员工详情', key: 'owner' },
    { label: '退出登录', key: 'logout' }
  ];

  private onMenuSelect(str: string) {
    switch (str) {
      case 'owner':
        this.doOwner();
        break;
      case 'logout':
        this.doLogout();
        break;
      case 'changePwd':
        this.doChangePwd();
        break;
    }
  }

  private async doOwner() {
    this.$router.push({ name: 'desk-staffDetail' });
  }

  private async doLogout() {
    try {
      await this.logout();
      this.$router.replace('/login');
    } catch (ex) {
      this.$message.error(ex.message);
    }
  }

  private async doChangePwd() {
    this.pwdVisible = true;
  }

  private onVisibleChange(b: boolean) {
    if (!b) {
      return;
    }
    this.$nextTick(() => {
      const el = ElementUIUtil.findDropdownPopover(this.$refs.theDropdown as Vue);
      if (el) {
        el!.classList.add('acgn-el-dropdown-popover-black');
      }
    });
  }
}
